import { render } from "./ThemesSlug.vue?vue&type=template&id=2538230f"
import script from "./ThemesSlug.vue?vue&type=script&lang=js"
export * from "./ThemesSlug.vue?vue&type=script&lang=js"

import "./ThemesSlug.vue?vue&type=style&index=0&id=2538230f&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__